/**
 * 📦 COMPOSANT : sellerie-app/frontend/src\pages\Parametres.tsx
 * Ce composant est utilisé dans d'autres pages de l'application
 */

import React, { useState } from 'react';
import { Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import MatieresList from './Parametres/MatieresList';
import TarifsCoefficients from './Parametres/TarifsCoefficients';
import Fournitures from './Parametres/Fournitures';
import MoussesList from './Parametres/MoussesList';

const Parametres: React.FC = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>(
    location.pathname.includes('/parametres/tarifs')
      ? 'tarifs'
      : location.pathname.includes('/parametres/fournitures')
      ? 'fournitures'
      : location.pathname.includes('/parametres/mousses')
      ? 'mousses'
      : 'matieres'
  );

  // Fonction pour déterminer si un onglet est actif
  const isActive = (tab: string) => {
    return activeTab === tab;
  };

  // Fonction pour changer d'onglet
  const changeTab = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Paramètres</h1>
        <p className="mt-1 text-sm text-gray-500">
          Configurez les paramètres de votre application pour personnaliser les calculs et les options disponibles.
        </p>
        <p className="mt-2 text-sm text-gray-600">
          Les calculs et devis générés par l’application reposent sur vos paramétrages (tarifs, matières, coefficients, TVA, frais, etc.) et sur les données saisies. Un contrôle final par le professionnel est nécessaire avant envoi au client.
        </p>
      </div>

      {/* Navigation par onglets */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          <Link
            to="/parametres"
            className={`${
              isActive('matieres')
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
            onClick={() => changeTab('matieres')}
          >
            Matières
          </Link>
          <Link
            to="/parametres/tarifs"
            className={`${
              isActive('tarifs')
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
            onClick={() => changeTab('tarifs')}
          >
            Tarifs et coefficients
          </Link>
          <Link
            to="/parametres/mousses"
            className={`${
              isActive('mousses')
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
            onClick={() => changeTab('mousses')}
          >
            Mousses
          </Link>
          <Link
            to="/parametres/fournitures"
            className={`${
              isActive('fournitures')
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
            onClick={() => changeTab('fournitures')}
          >
            Fournitures
          </Link>
        </nav>
      </div>

      {/* Contenu des onglets */}
      <div className="bg-white shadow rounded-lg">
        <Routes>
          <Route index element={<MatieresList />} />
          <Route path="tarifs" element={<TarifsCoefficients />} />
          <Route path="mousses" element={<MoussesList />} />
          <Route path="fournitures" element={<Fournitures />} />
          <Route path="*" element={<Navigate to="/parametres" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default Parametres;
